import { all, fork } from 'redux-saga/effects'
import { bblSaga } from './bbl'
import { customtextsSaga } from './customtexts'
import { userSaga } from './user'

export const rootSaga = function* root() {
  yield all([fork(userSaga), fork(bblSaga), fork(customtextsSaga)])
}
